import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { ScrollManager } from './components/ScrollManager';
import { Home } from './pages/Home';
import { ServicesIndex } from './pages/ServicesIndex';
import { ServiceDetail } from './pages/ServiceDetail';
import { NotFound } from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rit1x23ijoou">
      <ScrollManager data-id="element-1" data-mp="2mluawsf5bxuv" />
      <div className="w-full bg-white" data-id="element-2" data-mp="2mmcbg18ucy8l">
        <SiteHeader data-id="element-3" data-mp="2mnnh66lukg2c" />
        <main data-id="element-4" data-mp="2mjzo18kbdvo5">
          <Routes data-id="element-5" data-mp="31agn4l9h89hv">
            <Route path="/" element={<Home data-id="element-7" data-mp="31bianp7oiogh" />} data-id="element-6" data-mp="31ayr642drs0c" />
            <Route path="/services" element={<ServicesIndex data-id="element-9" data-mp="2wk9zanmsgt0o" />} data-id="element-8" data-mp="31ctdnmtavs6j" />
            <Route path="/services/:slug" element={<ServiceDetail data-id="element-11" data-mp="2whxcnx635uha" />} data-id="element-10" data-mp="2wiyv4mpflj91" />
            <Route path="*" element={<NotFound data-id="element-13" data-mp="28te37ebavbnm" />} data-id="element-12" data-mp="28tw5osok2m3z" />
          </Routes>
        </main>
        <SiteFooter data-id="element-14" data-mp="23vcm2yxfpmes" />
      </div>
    </BrowserRouter>;
}